import actions from "actions";

export type EntryReducer = {
  email: string;
  password: string;
  challengeResponse: string | null;
  error: string;
};

const initialState: EntryReducer = {
  email: "",
  password: "",
  challengeResponse: null,
  error: "",
};

function entry(state = initialState, action): EntryReducer {
  switch (action.type) {
    case actions.entry.CLEAR:
      return { ...initialState };
    case actions.entry.UPDATE_EMAIL:
      return { ...state, email: action.email };
    case actions.entry.UPDATE_CHALLENGE_RESPONSE:
      return { ...state, challengeResponse: action.challengeResponse };
    case actions.entry.UPDATE_ERROR:
      return { ...state, error: action.error };
    default:
      return state;
  }
}

export default entry;
